import { useCallback, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { convertURLParams, formatDateTime, parseSearchParams, secondsToTime } from "../../../../utils/helpers";
import { Chip, User } from "@nextui-org/react";
import Table from "../../components/Table/Table";
import HeaderContent from "../../components/Table/components/HeaderContent";
import FooterContent from "../../components/Table/components/FooterContent";
import { useGetLectureStudents } from "../hooks/useGetLectureStudents";
import { STORAGE_LINK } from "../../../../utils/constants";

function LectureStudentsTable() {
    const { search } = useLocation();
    const [searchValue, setSearchValue] = useState("");
    const [perPage, setPerPage] = useState(10);
    const [searchParams] = useSearchParams();

    const { courseId, lectureId } = useParams();

    const page = parseSearchParams(searchParams, "page", (value) => (parseInt(value, 10) < 1 ? 1 : parseInt(value, 10)), 1);

    // filter , sort , page
    const filterAndSortAndPageQuery = convertURLParams(search);

    const { lectureStudents, isPending } = useGetLectureStudents({
        params: { searchValue, perPage, page, filterAndSortAndPageQuery },
        courseId,
        lectureId,
    });

    //filterOptions
    const filterOptions = [
        { name: "مفعل", field: "status", value: "1" },
        { name: "غير مفعل", field: "status", value: "0" },
    ];

    //headerRows
    const headers = [
        { uid: "id", name: "#", sortable: true },
        { uid: "name", name: "اسم المستخدم", sortable: true },
        { uid: "email", name: "الإيميل", sortable: true },
        { uid: "status", name: "الحاله", sortable: true },
        { uid: "createdAt", name: "أنشئت في", sortable: true },
        { uid: "updatedAt", name: "تم التعديل في", sortable: true },
    ]

    //defaultHeaders
    const INITIAL_VISIBLE_COLUMNS = ["id", "name", "email", "status", "createdAt", "updatedAt"];

    //formatting Data
    const reformattedData = lectureStudents?.data?.map((item) => {
        const { id, attributes } = item;

        const lecturesStudentsData = { id, ...attributes };

        return { ...lecturesStudentsData };

    });

    const renderCell = useCallback(
        (row, columnKey) => {
            const cellValue = row?.[columnKey];
            switch (columnKey) {
                case "name":
                    return (
                        <User
                            avatarProps={{
                                radius: "full",
                                size: "sm",
                                src: row.image
                                    ? `${STORAGE_LINK}/images/users/${row?.image}`
                                    : "/images/userPlaceholder.webp",
                            }}
                            classNames={{ description: "text-default-500" }}
                            name={cellValue}>
                        </User>
                    );
                case "status":
                    return (
                        <Chip
                            className="gap-1 capitalize border-none text-default-600"
                            color={row.status ? "success" : "warning"}
                            size="sm"
                            variant="dot"
                        >
                            {cellValue == 1 ? "مفعل" : "غير مفعل"}
                        </Chip>
                    );
                case "createdAt":
                    return (
                        <span className="flex flex-col gap-2">
                            <span>
                                {formatDateTime(cellValue).formattedTime}
                            </span>
                            <span>
                                {formatDateTime(cellValue).formattedDate}
                            </span>
                        </span>
                    );
                case "updatedAt":
                    return (
                        <span className="flex flex-col gap-2">
                            <span>
                                {formatDateTime(cellValue).formattedTime}
                            </span>
                            <span>
                                {formatDateTime(cellValue).formattedDate}
                            </span>
                        </span>
                    );

                default:
                    return cellValue;
            }
        },
        [courseId]
    );

    const [visibleColumns, setVisibleColumns] = useState(
        new Set(INITIAL_VISIBLE_COLUMNS)
    );

    const totalPages = Math.ceil(
        lectureStudents?.meta?.total / lectureStudents?.meta?.per_page
    );

    return (
        <>
            <Table
                isloading={isPending}
                rows={reformattedData}
                headers={headers}
                visibleColumns={visibleColumns}
                renderCell={renderCell}
                columnsToCopy={["name"]}
                topContent={
                    <HeaderContent
                        filterOptions={filterOptions}
                        visibleColumns={visibleColumns}
                        setVisibleColumns={setVisibleColumns}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        placeholder="يمكنك البحث باسم المحاضره او الوصف او ال ID"
                        headers={headers}
                        rowsNumber={perPage}
                        setRowsNumber={setPerPage}
                        totalRows={lectureStudents?.meta?.total}
                        modalWidth="w-full md:w-[90%] lg:w-1/2"
                    />
                }
                bottomContent={<FooterContent totalPages={totalPages} />}
            />
        </>
    );
}
export default LectureStudentsTable;
